import { linkTargetResolver } from '@mntn-dev/app-routing'
import { Feed, type TagType } from '@mntn-dev/ui-components'
import { ActivityContainer } from '../activity-container.tsx'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../link.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectStatusChanged = ({
  activity,
  activity: {
    activityId,
    actor,
    details: {
      activityType,
      data: { target, status },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_status_changed'>) => (
  <ActivityContainer {...{ activity }}>
    <Feed.Summary>
      <ActivityTrans
        t={t}
        i18nKey={`${activityType}.${status}.summary`}
        values={{
          subject: actor.displayName,
          project: target.project,
        }}
      />
    </Feed.Summary>
    <Feed.Annotations>
      <Feed.Tag
        type={t(`${activityType}.${status}.tag`) as TagType}
        dataTestId={`activity-feed-item-${activityId}-status-tag`}
        dataTrackingId={`activity-feed-item-${activityId}-status-tag`}
      >
        {t(`${activityType}.${status}.status`)}
      </Feed.Tag>
      <Link
        {...{
          target: linkTargetResolver.project({ target }),
          t,
          onNavigate,
          currentUrl,
          dataTestId: `activity-feed-item-${activityId}-view-project-link`,
          dataTrackingId: `activity-feed-item-${activityId}-view-project-link`,
        }}
      />
    </Feed.Annotations>
  </ActivityContainer>
)
